import React, { useState, useRef } from 'react';
import { Button, Popover, MenuItem, ListItemIcon } from '@mui/material';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from '../Modal';
import { useModal } from '../../../hooks/useModal';
import Tooltip from '../Tooltip';
import { MainContainer } from './styles';
import { useStore } from '../../../stores/useStore';
import useNotifications from '../../../hooks/useNotification';
import CustomNotification from '../CustomNotification';
import { useMultipleEditionStore } from '../../../stores/useMultipleEditionStore';

const ApprovedButton = ({ isApproved, comment, onReject, id_attribute, openModal, closeModal, articleId, company_id, selectedSection }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [status, setStatus] = useState(isApproved ? 'approved' : comment ? 'rejected' : 'doNotDisturb');
  const inputRef = useRef(null); 
  // const { modalData, openModal, closeModal, handleCancelClick } = useModal();
  // const store = useStore((state) => state.currentData);
  // const {setDataObjAproval, getSingleObj, } = useStore();
  const { setMultipleDataObjAproval, getSingleAttributeObj } = useMultipleEditionStore();
  // console.log("currentData =>", currentData);
  const obj = getSingleAttributeObj(articleId, id_attribute);
  // console.log("obj =>", obj);

  const { notifications, addNotification, deleteNotification } =
    useNotifications();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApprove = () => {
    if (onReject) {
      // onReject(true, null);
      setMultipleDataObjAproval(articleId, id_attribute, 1, null);
    }
    handleClose();
    setStatus('approved');
  };

  const handleReject = () => {
    handleClose();

    //Validar si el que se esta rechazando lo podrá visualizar proveedor

    const isVisibleToProvider = obj?.onboarding_visibility === "RETAILER_PROVIDER";

    //Si el ID de compañia es 1543 -> Compras
    if(!isVisibleToProvider && company_id === 1543 && selectedSection === 'datasheet') {
      openModal({
        className: 'modal-reject',
        title: 'No es posible rechazar este atributo',
        customComponent: (
          <p style={{
            fontSize: "15px",
            lineHeight: "1.25rem"
          }}>
            Este atributo no es visible para el proveedor y por consecuencia no podrá modificarlo.
          </p>
        ),
        showAccept: true,
        showCancel: false,
        onAcceptClick: () => closeModal(),
      });
      return;
    }

    openModal({
      className: 'modal-reject',
      title: 'Escribe el mensaje de rechazo:',
      customComponent: (
        <textarea
          className="reject-textarea"
          ref={inputRef}
          placeholder="Escribe tu razón aquí..."
          rows={4}
          cols={50}
        />
      ),
      showAccept: true,
      showCancel: true,
      onAcceptClick: handleAcceptClick,
    });
  };

  const handleAcceptClick = () => {
    const value = inputRef.current.value;
    if(!value) {
      addNotification('error', 'El motivo de rechazo es necesario');
      return;
    }
    if (onReject) {
      // onReject(false, value);
      setMultipleDataObjAproval(articleId, id_attribute, 0, value);
    }
    inputRef.current.value = '';
    closeModal();
    setStatus(value ? 'rejected' : 'doNotDisturb');
  };

  const renderIcon = () => {
    if (obj?.isApproved === undefined){
      return (
            <Tooltip title="Debes aprobar o rechazar para continuar" position="top" variant="white">
              <DoNotDisturbOnIcon sx={{ color: 'var(--purple-light-contentoh)' }} />
            </Tooltip>
          );
    }

    if (obj?.isApproved) {
      return <CheckCircleIcon sx={{ color: 'var(--secondary-color)' }} />;
    } 

    return (
          <Tooltip title={`Motivo de rechazo: ${comment}`} position="top" variant="white">
            <CancelIcon sx={{ color: 'var(--error-color)' }} />
          </Tooltip>
        );
    // else if (!obj?.isApproved) {
    //   return (
    //     <Tooltip title="Debes aprobar o rechazar para continuar" position="top" variant="white">
    //       <DoNotDisturbOnIcon sx={{ color: 'var(--purple-light-contentoh)' }} />
    //     </Tooltip>
    //   );
    // } else { 
    //   return (
    //     <Tooltip title={`Motivo de rechazo: ${comment}`} position="top" variant="white">
    //       <CancelIcon sx={{ color: 'var(--error-color)' }} />
    //     </Tooltip>
    //   );
    // }
  };

  return (
    <MainContainer>
      <Button onClick={handleClick} sx={{ minWidth: '30px' }}>
        {renderIcon()}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={handleApprove} sx={{ fontSize: '0.75rem' }}>
          <ListItemIcon sx={{ minWidth: '30px' }}>
            <CheckCircleIcon sx={{ color: 'var(--secondary-color)' }} />
          </ListItemIcon>
          Validar
        </MenuItem>
        <MenuItem onClick={handleReject} sx={{ fontSize: '0.75rem' }}>
          <ListItemIcon sx={{ minWidth: '30px' }}>
            <CancelIcon sx={{ color: 'var(--error-color)' }} />
          </ListItemIcon>
          Rechazar
        </MenuItem>
      </Popover>

      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
    </MainContainer>
  );
};

export default ApprovedButton;